import React from "react"
import { Nav, NavItem, NavLink, TabContent, TabPane, Card } from "reactstrap"
import { useSelector } from "react-redux"
import Pants from "./tabs/Pants"
import Jacket from "./tabs/Jacket"
import Skeleton from "react-loading-skeleton"
import Image from "./Image"
import Repiar from "./tabs/Repair"

function DetailInspection({ tabs }) {
  const store = useSelector(state => state)
  const [active, setActive] = React.useState("手書き")

  React.useEffect(() => {
    if (tabs.length) {
      setActive(tabs[0].key)
    }
  }, [tabs])
  const handwriting = store?.inspection?.orderSize?.data?.handwriting

  const [tempCourselImage, setTempCourselImage] = React.useState([])

  React.useEffect(() => {
    if (handwriting) {
      const temp = []
      handwriting?.details.forEach((h, i) => {
        temp.push({ src: h.image, altText: "Slide" + i, caption: "Slide " + i })
      })
      setTempCourselImage(temp)
    }
  }, [handwriting])

  if (store.inspection.orderSize.loading) {
    return <Skeleton count={5} />
  }

  // if (!handwriting) return null

  return (
    <div>
      <Nav tabs>
        {tabs.map((i, k) => (
          <NavItem key={k}>
            <NavLink
              href="#"
              active={active == i.key}
              onClick={() => setActive(i.key)}
            >
              {i.title}
            </NavLink>
          </NavItem>
        ))}

        {handwriting && (
          <NavItem>
            <NavLink
              href="#"
              active={active == "手書き"}
              onClick={() => setActive("手書き")}
            >
              手書き
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={active}>
        <TabPane tabId="jacket">
          <Jacket />
        </TabPane>
        <TabPane tabId="pants">
          <Pants />
        </TabPane>
        <TabPane tabId="repair">
          <Repiar />
        </TabPane>
        <TabPane tabId="手書き">
          <Card body style={{ height: 585 }}>
            <Image handwriting={tempCourselImage} />
          </Card>
        </TabPane>
      </TabContent>
    </div>
  )
}

export default DetailInspection
